/**
 * Created by Aleksandr on 15.09.2022.
 */

const SnapshotBar = function () {
    this.isButtonsVisible = true;

    this.onShowButtons = function () {};
    this.onHideButtons = function () {};
    this.onUpdateAdminButton = function () {};
    this.onUpdate = function () {};

    cleverapps.environment.on("changeScene", this.update.bind(this), this);
};

SnapshotBar.prototype.update = function () {
    this.onUpdate();
};

SnapshotBar.prototype.createView = function () {
    let isInIframe;
    try {
        isInIframe = window.self !== window.top;
    } catch (e) {
        isInIframe = true;
    }

    if (isInIframe) {
        return;
    }

    cleverapps.bundleLoader.loadBundle("dev_snapshots", {
        onSuccess: function () {
            new SnapshotBarView();
        }
    });
};

SnapshotBar.prototype.photo = function () {
    cleverapps.snapshots.createSnapshot();
};

SnapshotBar.prototype.hideButtons = function () {
    this.isButtonsVisible = false;
    this.onHideButtons();
};

SnapshotBar.prototype.showButtons = function () {
    this.isButtonsVisible = true;
    this.onShowButtons();
};

SnapshotBar.prototype.toggleButtons = function () {
    if (this.isButtonsVisible) {
        this.hideButtons();
    } else {
        this.showButtons();
    }
};

SnapshotBar.prototype.updateAdminButton = function () {
    this.onUpdateAdminButton();
};